import styled, { CSSObject } from '@emotion/styled';
import { QcsCheckbox } from '../basic/QcsCheckbox';
import { QcsMenuItem } from '../basic/QcsMenuItem';

export const MenuItemWithCheckbox = styled(QcsMenuItem)(() => ({
  display: 'flex',
  gap: '0.5rem',
  paddingLeft: '0.5rem',
}));

export const CheckboxInMenuItem = styled(QcsCheckbox)(() => ({
  padding: '0.2rem',
}));

export const InputWithButtonContainer = styled.div((): CSSObject => ({
  display: 'grid',
  gridTemplateColumns: 'auto max-content',
  gap: '0.5rem',
}));
